
















import { Component, Prop, Vue } from 'vue-property-decorator';
// import { Tag } from 'element-ui';
@Component({
  name: 'lb-tag'
  // components: {
  //   'el-tag': Tag
  // }
})
export default class extends Vue {
  @Prop({ type: Boolean }) private closable!: boolean;
  @Prop() private type!: string;
  @Prop({ type: Boolean }) private hit!: boolean;
  @Prop({ type: Boolean }) private disableTransitions!: boolean;
  @Prop() private color!: string;
  @Prop() private size!: string;
  @Prop({
    default: 'light',
    validator(val) {
      return ['dark', 'light', 'plain'].indexOf(val) !== -1;
    }
  }) private effect!: string;

  private handleClick() {
    this.$emit('click')
  }

  private handleClose() {
    this.$emit('close')
  }
}
